export const DEFAULT_COMPANY: Record<AppLocale, string> = {
  en: 'Al Shafaq Auto Spare Parts Trading LLC',
  fr: 'Al Shafaq Auto Spare Parts Trading LLC',
  ar: 'الشفاق لتجارة قطع غيار السيارات ذ.م.م',
}

export const DEFAULT_ADDRESS: Record<AppLocale, string> = {
  en: 'Industrial Area 3, Sharjah, U.A.E.',
  fr: 'Zone industrielle 3, Sharjah, Émirats arabes unis.',
  ar: 'المنطقة الصناعية 3، الشارقة، الإمارات العربية المتحدة.',
}

export const DEFAULT_FOOTER_ADDRESS: Record<AppLocale, string> = {
  en: `${DEFAULT_COMPANY.en}\n${DEFAULT_ADDRESS.en}`,
  fr: `${DEFAULT_COMPANY.fr}\n${DEFAULT_ADDRESS.fr}`,
  ar: `${DEFAULT_COMPANY.ar}\n${DEFAULT_ADDRESS.ar}`,
}
